import { render, staticRenderFns } from "./CollapsibleAdminOptions.vue?vue&type=template&id=64cd42b6&"
import script from "./CollapsibleAdminOptions.vue?vue&type=script&lang=ts&"
export * from "./CollapsibleAdminOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports